import { formatNumberWithCommas } from "../../../helpers";

const firstDefined = (user: any, keys: string[]) => {
  for (const source of [user, user?.stats]) {
    if (!source) continue;
    for (const key of keys) {
      const value = source[key];
      if (value !== undefined && value !== null) return value;
    }
  }
  return null;
};

const toFiniteNumber = (value: unknown): number | null => {
  if (value === undefined || value === null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const getUserOrderAmount = (user: any) =>
  toFiniteNumber(
    firstDefined(user, ["orderAmount", "totalOrderAmount", "totalOrderValue"]),
  );

export const getUserOrderCount = (user: any) =>
  toFiniteNumber(
    firstDefined(user, ["orderCount", "totalOrderCount", "totalOrders"]),
  );

export const getUserProductCount = (user: any) =>
  toFiniteNumber(
    firstDefined(user, ["productCount", "totalProductCount", "productsCount"]),
  );

export const formatUserAmount = (user: any) => {
  const n = getUserOrderAmount(user);
  return n == null ? "N/A" : `₦${formatNumberWithCommas(n)}`;
};

export const formatUserCount = (value: number | null) =>
  value == null ? "N/A" : formatNumberWithCommas(value);
